/**
 * QL-375 group 8 — the existing-vs-new card's copy (screen 12), en_GB + nb_NO.
 * Read with `useT(T)`.
 */

export const T = {
  en_GB: {
    title: "Mandate",
    description: "What the bank holds today, and what this advice proposes instead.",
    fetchError: "Could not load the mandate comparison.",
    retry: "Retry",
    existingGroup: "Existing mandate · at the bank",
    proposedGroup: "New mandate · proposed",
    colName: "Name",
    colIsin: "ISIN",
    colMin: "Min",
    colDefault: "Default",
    colMax: "Max",
    colWeight: "Weight",
    changed: "changed",
    removed: "not in the new mandate",
    footer:
      "The advice is checked against the new mandate, because that is what the client is being advised to hold under. The existing one stays as the bank's record until the bank changes it.",
    frozen: "Frozen with the submitted advice.",
  },
  nb_NO: {
    title: "Mandat",
    description: "Det banken har i dag, og det dette rådet foreslår i stedet.",
    fetchError: "Kunne ikke laste mandatsammenligningen.",
    retry: "Prøv igjen",
    existingGroup: "Eksisterende mandat · hos banken",
    proposedGroup: "Nytt mandat · foreslått",
    colName: "Navn",
    colIsin: "ISIN",
    colMin: "Min",
    colDefault: "Standard",
    colMax: "Maks",
    colWeight: "Vekt",
    changed: "endret",
    removed: "ikke i det nye mandatet",
    footer:
      "Rådet kontrolleres mot det nye mandatet, fordi det er det kunden rådes til å holde seg innenfor. Det eksisterende blir stående som bankens register til banken endrer det.",
    frozen: "Fryst med det innsendte rådet.",
  },
} as const;
